export default __webpack_public_path__ + "static/media/kronos.25db0a74.svg";